export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `Llegadas de hoy`,
        tomorrow: `Llegadas de mañana`,
        this_week: `Llegadas de esta semana`,
        month: `Llegadas de este mes`,
        upcoming: `Próximas llegadas`,
    },
    filtroSalidas: {
        today: `Salidas de hoy`,
    },
    quitarFiltro: `Quitar filtro`,
    // Estancia vendida por horas registrada como reserva
    rapida: `Rápida`,
    p1:`Listado de reservas`,
    p2:`Listado de las reservas registradas en la plataforma`,
    p3:`Más acciones`,
    p4:`Programar Check-in`,
    p5:`Hoy`,
    p6:`Código de reserva`,
    p7:`Nombre`,
    p8:`Email`,
    p9:`Fecha de ingreso`,
    p10:`Deposito`,
    p11:`Número de huéspedes`,
    p12:`Estado: `,
    p13:`Cantidad: `,
    p14:`Estado: `,
    p15:`Pendiente`,
    p16:`Completo`,

    p17:`Más acciones`,
    p18:`Importar reservas`,
    p19:`Descargue una plantilla de Excel, rellene los datos de su reserva y cárguela para crear varias reservas simultáneamente.`,

    p20:`Check-in Prog.`,
    p21:`Información detallada del check-in programado`,
    p22:`Estado `,
    p23:`Pagada`,
    p24:`Pendiente por pagar`,
    p25:`Cambiar estado del pago`,
    p26:`Responsable del check-in`,
    p27:`Enviar check-in online`,
    p28:`Enviando link del check-in ...`,
    p29:`Enviar check-in online a los huéspedes automáticamente`,
    p30:`Una semana antes del check-in`,
    p31:`72 horas antes del check-in`,
    p32:`48 horas antes del check-in`,
    p33:`24 horas antes del check-in`,
    p34:`Guardar cambios`,
    p35:`fecha de ingreso`,
    p36:`fecha de salida`,
    p37:`Huéspedes registrados`,
    p38:`Listado de check-in realizados.`,
    p39:`Nombre`,
    p41:`Apellido`,
    p42:`Fecha del check-in`,
    p43:`Email`,
    p44:`Proceso`,
    p45:`Escaneado`,
    p46:`Manual`,
    p47:`Manual operador`,
    p48:`Teléfono`,
    p49:`No hay check-in registrados`,

    p50:`Estado del pago de la reserva`,
    p51:`Cambia de forma manual el estado del pago de la reserva.`,
    p52:`Selecciona una de las opciones`,
    p53:`Pendiente`,
    p54:`Pagada`,
    p55:`Cancelar`,
    p56:`Cambiar estado`,
    p57:`Sin especificar`,
    p58:`Completo`,
    p59:`Aun no hay reservas registradas`,
    p60:`Check-in programados`,
    p61:`Los cambios se guardaron con éxito`,
    p62:`¿Quieres enviar el link de check-in?`,
    p63:`Enviar link`,
    p64:`Cancelar`,
    p65:`Petición de check-in enviado con éxito`,

    p66:`No se ha encontrado la propiedad o el usuario.`,
    p67:`Error al generar token`,
    p68:`Error al conectar con el canal. Por favor intente nuevamente.`,
    p69:`Disponibilidad y Tarifas`,
    p70:`Gestiona los días y tarifas disponibles en tu alojamiento`,
    p71:`Para activar esta función, necesitas tener un plan activo. Podrás ver la disponibilidad de tu alojamiento al instante, cambiar tarifas según la temporada o eventos especiales y ajustar todo desde un solo lugar.`,
    p72:`Al cancelar esta reserva, las fechas estarán disponibles en cualquier portal conectado`,
    p73:`Cancelar reserva`,
    p74:`Reserva cancelada con éxito`,
    p75:`Reserva de `,
    p76:` cancelada.`,
    p77:`No puedes reservar en fechas cerradas.`,
    p78:`Verifica las fechas seleccionadas`,
    p79:`Debes seleccionar al menos una noche para la reserva.`,
    p80:`Las fechas seleccionadas no están disponibles.`,
    p81:`Recordatorios`,
    p82:`Gestiona los recordatorios para tus huéspedes`,
    p83:`Crear nuevo recordatorio`,
    p84:`Día`,
    p85:`Hora`,
    p86:`Descripción`,
    p87:`Eliminar recordatorio`,
    p88:`No se encontraron recordatorio registrados`,
    p89:`¿Seguro quieres eliminar el recordatorio?`,
    p90:`Perderas los datos guardados`,
    p91:`Eliminar recordatorio`,
    p92:`Recordatorio eliminado con éxito`,
    p93:`Primer paso:`,
    p94:`Selecciona el país donde tienes las reservas y descarga la plantilla para rellenar los datos.`,
    p95:`Descargar plantilla`,
    p96:`Segundo paso:`,
    p97:`Sube la misma plantilla o plantillas que has descargado con los datos añadidos.`,
    p98:`Importar`,
    p99:`Debe subir la planilla para continuar con la importación`,
    p100:`Proceso realizado con éxito`,
    p101:`Error en el proceso de importación`,
    p102:`Disponible`,
    p103:`Ocupado`,
    p104:`En limpieza`,
    p105:`Mantenimiento`,
    p106:`Error al cancelar la reserva`,
    p107:`Error al actualizar la vista después de cancelar`,
    p108:`No se pudo abrir el cambio de habitación. Reserva inválida.`,
    p109:`No se pudo identificar la habitación actual.`,
    p110:`Disponibilidad actualizada correctamente`,
    p111:`Calendario Hotelero`,
    p112:`Administra tus reservas de forma visual y mantén el control total de la disponibilidad de tu hotel.`,
    p113:`Cambiar disponibilidad`,
    p114:`Crear reserva`,
    p115:`Las reservas pausadas no se enviarán automáticamente`,
    p116:`Se activará el envío automático para esta reserva`,
    p117:`Pausar`,
    p118:`Activar`,
    p119:`la reserva`,
    p120:`Si`,
    p121:`Reserva pausada con éxito`,
    p122:`proceso realizado correctamente`,
    p123:`Reserva activada con éxito`,
    p124:`Reservas sincronizadas y creadas manualmente`,
    p125:`Fecha inválida`,
    p126:`Invalid Date`,
    p127:`Se enviará invitación de check-in el `,
    p128:`Reserva en pausa`,
    p129:`Reserva cancelada`,
    p130:`Completar`,
    p131:`Aquí aparecerán todas tus reservas con los detalles de cada check-in y huésped. Cuando llegue tu primera reserva, la verás justo aquí.`,
    p132:`Propiedad seleccionada`,
    p133:`Múltiple`,
    p134:`Mensual`,
    p135:`Cerrado`,
    p136:`Fechas actualizadas exitosamente`,
    p137:`Error al cargar los datos de la propiedad`,
    p138:`Las fechas seleccionadas no están disponibles. Hay reservas o fechas cerradas que causan conflicto.`,
    p139:`Reserva creada exitosamente`,
    p140:`Rango`,
    p141:`cerrado con éxito`,
    p142:`Error al cerrar fechas`,
    p143:`Error al eliminar fechas cerradas`,
    p144:`Precios actualizados exitosamente`,
    p145:`Error al actualizar los precios`,
    p146:`¿Estás seguro de que deseas cancelar esta reserva?`,
    p147:`Confirmar cancelación`,
    p148:`Sí, cancelar`,
    p149:`No`,
    p150:`Reserva cancelada exitosamente`,
    p151:`Error al cargar las propiedades`,
    p152:`Nueva reserva agregada al calendario`,
    p153:`Esta reserva proviene de un canal externo (OTA). No se recomienda cancelarla directamente desde este sistema. Por favor, contacta al huésped y solicita que cancele la reserva a través del canal original donde fue realizada.`,
    p154:`Reserva OTA - Cancelación no permitida`,
    p155:`Entendido`,
    p156:`Error al procesar la solicitud`,
    p157:`El enlace se copió con éxito`,
    p158:`¡Copiado!`,
    p159:`Hubo un error al copiar el enlace`,
    p160:`Error`,
    p161:`Enviar check-in al responsable de la reserva`,
    p162:`Enviar check-in`,
    p163:`Enviar`,
    p164:`Error al cargar la reserva`,
    p165:`Información de check-in`,
    p166:`Enviar petición de check-in`,
    p167:`Todas las reservas`,
    p168:`Próximas reservas`,
    p169:`Reservas canceladas`,
    p170:`Huespedes`,
    p171:`Fecha de entrada`,
    p172:`Entrada`,
    p173:`Confirmada`,
    p174:`Sobrerreserva`,
    p175:`Cancelada`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}